<div>
  <app-search-bar
    [placeholder]="'Search'"
    [(filterParameter)]="itzFilter"
    (searchEvent)="search()"
    (resetFilterEvent)="resetFilter()"
    >
  </app-search-bar>

  <!-- Checkbox to display inactive users -->
  <div class="row mt-3 checkbox-row">
    <input type="checkbox" name="displayInactiveUsers"
      [(ngModel)]="displayInactiveUser"
      id="displayInactiveUsers" class="professional-checkbox">
      <label for="displayInactiveUsers" class="professional-checkbox-label">Display inactive users</label>
    </div>

    <!-- List of Itz users filtered based on search and displayInactiveUser property -->
    <div class="list-group">
      @for (itz of $itzList | filter:itzFilter : displayInactiveUser; track itz) {
        @if (!shouldHideUser(itz)) {
          <div class="list-group-item-container" [routerLink]="[itz.id, '/modification']">
            <div class="list-group-item" [class.inactive-user]="itz.userStatus === 'INACTIVE'">
              <div class="row-picture">
                @if (itz.avatar) {
                  <img [ngClass]="getStyle(itz)" [src]="itz.avatar" alt="avatar"/>
                } @else {
                  <div [ngClass]="getStyle(itz)">{{ itz.userLogin | trigrammePipe }}</div>
                }
              </div>
              <div class="row-content">
                <span class="list-group-item-heading">{{ itz.userFirstName }} {{ itz.userName }}</span>
                <div class="list-group-item-text">
                  @if (itz.userStatus === 'INACTIVE') {
                    <span class="inactive-label">Inactive</span>
                  }
                </div>
              </div>
            </div>
            <div class="list-group-separator"></div>
          </div>
        }
      }
    </div>
  </div>

  <button class="professional-create-button" (click)="initInformationInputForm()">
    <i class="material-icons size-xxl">person_add</i>
  </button>

  @if (showCreateModal) {
    <div class="modal-overlay">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Création d'un nouvel utilisateur</h5>
          </div>
          <div class="modal-body">
            @if (selectedUser) {
              <div class="panel panel-default">
                <div class="panel-heading">
                  <h4 class="panel-title">Informations</h4>
                </div>
                <div class="panel-body">
                  <user-information-tab
                    [user]="selectedUser"
                    (userUpdated)="onUserUpdated($event)"
                    (closeModal)="showCreateModal = false"
                    (resetPassword)="showResetModal=true">
                  </user-information-tab>
                </div>
              </div>
            }
          </div>
          <div class="modal-footer">
            <button class="btn btn-default" (click)="showCreateModal = false">Fermer</button>
          </div>
        </div>
      </div>
    </div>
  }
